import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=295fd0c0&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('295fd0c0')) {
      api.createRecord('295fd0c0', component.options)
    } else {
      api.reload('295fd0c0', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=295fd0c0&", function () {
      api.rerender('295fd0c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2MNPg67fAAxlS/JS/comp/ErrorMessage.vue"
export default component.exports